<template>
  <section class="confirm-submit mx-auto text-center">
    <div class="confirm-submit-content">
      <div class="confirm-submit-title typography-headline-6">
        {{ $t('viewer.confirm_submit.title') }}
      </div>
      <div class="confirm-submit-message typography-subtitle-1"
          v-html="$t('viewer.confirm_submit.message')">
      </div>
    </div>
    <div class="sticker-img">
      <img
        src="@/assets/images/class-end.png"
        width="120"
        height="140"
      >
    </div>
    <div class="confirm-btn-area">
      <router-link
        :to="{
          name: 'cards.results',
          params: { cardId: routeParams.cardId }
        }"
        tag="button"
        class="btn btn-primary btn-block">
        {{ $t('viewer.confirm_submit.submit_btn') }}
      </router-link>
    </div>
    <div class="cancel-btn-area">
      <router-link
        :to="{
          name: 'pages.show',
          params: { cardId: routeParams.cardId, page: 1 }
        }"
        tag="button"
        class="btn btn-inverted-primary btn-block"
      >
        {{ $t('viewer.confirm_submit.review_btn') }}
      </router-link>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash';

export default {
  name: 'confirm-submit',

  computed: {
    ...mapGetters({
      routeParams: 'getRouteParams',
      page: 'getPage',
      card: 'getCard',
    }),
  },

  created() {
    if (isEmpty(this.card)) {
      this.$router.replace({ name: 'cards.show', params: { cardId: this.routeParams.cardId } });
    }
  },
};
</script>

<style lang="scss">
  .confirm-submit {
    padding-top: 20px;
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 20px;
    max-width: 602px;

    .confirm-submit-title {
      font-weight: bold;
      text-align: center;
      color: #00c896;
      padding: 12px;
    }

    .confirm-submit-content {
      background: #ffffff;
      padding: 14px;
      max-width: 420px;
      margin: 0 auto;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      border-radius: 0.5px;

      @media (min-width: 576px) {
        padding: 24px;
        max-width: 576px;
      }
    }

    .sticker-img {
      padding-bottom: 24px;
      padding-top: 24px;

      @media (min-width: 576px) {
        padding-bottom: 10px;
      }
    }

    .confirm-btn-area {
      padding-top: 14px;

      .btn {
        font-size: 14px;
        padding-top: 16px;
        padding-bottom: 16px;
      }
    }

    .cancel-btn-area {
      padding-top: 14px;
      padding-bottom: 32px;

      @media (min-width: 576px) {
        padding-top: 16px;
      }

      .btn {
        font-size: 14px;
        padding-top: 16px;
        padding-bottom: 16px;
      }
    }
  }
</style>
